import { ChangeDetectorRef, Component, ElementRef, EventEmitter, HostListener, Input, Output, ViewChild, computed, inject, input } from '@angular/core';
import { SelectedAttributeService } from '../../services/selected-attribute.service';
import { MatSlideToggleChange } from '@angular/material/slide-toggle';
import { GoogleAnalyticsService } from 'src/app/services/google-analytics/google-analytics.service';

@Component({
  selector: 'app-attribute-filter',
  templateUrl: './attribute-filter.component.html',
  styleUrls: ['./attribute-filter.component.scss']
})
export class AttributeFilterComponent {
  private selectedAttributeService = inject(SelectedAttributeService);
  private changeDetectorRef = inject(ChangeDetectorRef);
  private googleAnalyticsService = inject(GoogleAnalyticsService);
  gridColumn: string | null = null;
  placeholder = input('Filter');
  @Input() set colSpan(span: number | string) {
    this.gridColumn = !span ? '' : `1 / span ${span}`;
  }

  @Input() animationDirection: 'In' | 'Out' | null = null;
  @Input() data: any[] = [];
  @Input() valueExtractor: (a: any) => string = this.defaultExtractor;
  @Output() animationEnd = new EventEmitter();
  @Output() closeClick = new EventEmitter();
  @Output() filterChange = new EventEmitter();
  searchText: string | null = "";
  shouldShowUnavailable = computed(() => this.selectedAttributeService.shouldShowUnavailable());
  shouldShow = true;
  @ViewChild('search') searchInput!: ElementRef<HTMLInputElement>;

  defaultExtractor(a: any) {
    return a.toString();
  }

  searchTextChange() {
    const filteredData = this.filterData();
    this.filterChange.emit(filteredData);
  }

  filterData() {
    const text = this.searchText?.toLowerCase();
    if (text) {
      const startsWith = this.data.filter((d: any) => this.valueExtractor(d).toLowerCase().startsWith(text));
      const includes = this.data.filter((d: any) => this.valueExtractor(d).toLowerCase().includes(text) && !startsWith.some(sw => this.valueExtractor(sw).toLowerCase() === this.valueExtractor(d).toLowerCase()));
      return startsWith.concat(includes);
    }
    return this.data;
  }

  @HostListener('animationend', ['$event.target'])
  viewContainerAnimationEnd(target: HTMLElement) {
    if (target.classList.contains('FilterContent')) {
      this.animationEnd.emit();
    }
  }

  showUnavailableChange(value: boolean) {
    this.selectedAttributeService.shouldShowUnavailable.set(value);
  }

  toggleShow(force?: boolean) {
    this.shouldShow = force ?? !this.shouldShow;
  }

  searchClick() {
    this.toggleShow();
    this.changeDetectorRef.detectChanges();
    if (this.shouldShow) {
      this.searchInput.nativeElement.focus();
    }
  }

  onSearchBlur() {
    if (this.googleAnalyticsService.isInitialized && this.searchText) {
      this.googleAnalyticsService.triggerEvent('search', 'attribute_filter', 'search_filter', this.searchText);
    }
  }

  closeClicked() {
    this.toggleShow(false);
    this.closeClick.emit();
  }
}
